import { Columns, Column, Button, Stack } from 'braid-design-system';
import debounce from 'lodash/debounce';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import type { ListingProduct } from 'src/generated/graphql';

import { usePaymentSubmission } from '../../../hooks/usePaymentSubmission';

import { AcceptedCards } from './components/AcceptedCards/AcceptedCards';
import { CheckoutForm } from './components/CheckoutForm/CheckoutForm';
import { CheckoutFormErrorView } from './components/CheckoutFormErrorView/CheckoutFormErrorView';
import { PaymentHeading } from './components/PaymentHeading/PaymentHeading';
import { SearchBoostProductDetails } from './components/ProductDetails/SearchBoostProductDetails';

interface SearchBoostPaymentScreenProps {
  searchBoostProduct: ListingProduct;

  clientId: string;
  listingId: string | null;
}

export const SearchBoostPaymentScreen = (
  props: SearchBoostPaymentScreenProps,
) => {
  const { pay, loading, error } = usePaymentSubmission();

  const handleSubmit = debounce(async () => {
    await pay({
      clientId: props.clientId,
      listingId: props.listingId,
      selectedProduct: props.searchBoostProduct,
      sourceProducts: [props.searchBoostProduct],
    });
  }, 500);

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        handleSubmit();
      }}
    >
      <Columns space="medium" collapseBelow="desktop">
        <Column width="2/5">
          <Stack space="large">
            <PaymentHeading />

            {loading ? (
              <CustomLoader />
            ) : (
              <Stack space="medium">
                <AcceptedCards />

                <CheckoutForm />

                <Button type="submit" tone="formAccent">
                  Pay ${props.searchBoostProduct.cost / 100} + GST
                </Button>

                {error && <CheckoutFormErrorView error={error} />}
              </Stack>
            )}
          </Stack>
        </Column>

        <Column>
          <SearchBoostProductDetails
            searchBoostProduct={props.searchBoostProduct}
          />
        </Column>
      </Columns>
    </form>
  );
};
